import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ISesion } from '../store/app.store.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private SIGO_SESSION_KEY = "SIGO_SESION_ACTUAL";
  private sesionActual: ISesion;
  public jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(/*private jwtHelper: JwtHelperService*/) {
    
  }


  setSesion = (token: string) => {
    console.log('setSesion');
    let sesion : ISesion = this.jwtHelper.decodeToken(token);
    console.log(sesion);
    localStorage.setItem(this.SIGO_SESSION_KEY, token);
    this.sesionActual = sesion;
  }

  getSesion = () : ISesion => {
    console.log('getSesion');
    return this.sesionActual;
  }
 
  esSesionValida = 
  () => {
    let token = localStorage.getItem(this.SIGO_SESSION_KEY);
    return !this.jwtHelper.isTokenExpired(token) /*&& casillaActual*/;
  }

  limpiarSesion = () => {
    this.sesionActual = null;
    localStorage.removeItem(this.SIGO_SESSION_KEY);
  }
}

// import { Injectable } from "@angular/core";
// import { IAppUser, ISesion, ISesionSTS } from "../store/app.store.interface";

// /*STS*/
// import { User, UserManager, UserManagerSettings } from "oidc-client";
// import { from, Subject, throwError } from "rxjs";
// import { environment } from "src/environments/environment";
// import { HttpClient } from "@angular/common/http";
// import { catchError, map, switchMap } from "rxjs/operators";
// import { TipoPerfilSIGO, TipoPerfilSTS } from "../store/app.store.model";

// @Injectable({
//   providedIn: "root",
// })
// export class AuthService {
//   private userSesion: IAppUser;

//   private url: string = environment.identidadesUrl + `/${environment.identidadesSeguridadUrl}`;
//   private userManager: UserManager;
//   private user: User;
//   private _loginChangedSubject = new Subject<boolean>();
//   public loginChanged = this._loginChangedSubject.asObservable();

//   headers = new Headers();

//   constructor(private http: HttpClient) {
//     this.userManager = new UserManager(this.idpSettings);
//   }

//   //Metodo que validara si el usuario existe y si no expira
//   private checkUser = (user: User): boolean => {
//     return !!user && !user.expired;
//   };

//   //Configuracion base para poder conectarse al STS
//   private get idpSettings(): UserManagerSettings {
//     return {
//       authority: environment.loginUrl,
//       client_id: environment.idpClientId,
//       redirect_uri: `${environment.idpClientRoot}/login/signin-callback`,
//       scope: "openid profile " + environment.idpClientResources,
//       response_type: "code",
//       post_logout_redirect_uri: `${environment.idpClientRoot}/login/signout-callback`,
//     };
//   }

//   //Metodo que redirecciona al STS : Inicia Sesion
//   setSesion = () => {
//     return this.userManager.signinRedirect();
//   };

//   //Metodo que devuelve token que nos da el STS
//   public getToken = async (): Promise<string> => {
//     return this.userManager.getUser().then((user) => {
//       return !!user && !user.expired ? user.access_token : null;
//     });
//   };

//   public getUserIdSTS = async (): Promise<number> => {
//     let tokenSTS = await this.getToken();
//     this.headers.append("Content-Type", "application/json");
//     this.headers.append("Authorization", "Bearer " + tokenSTS);
//     return this.http
//       .get(`${this.url}/Autoriza`)
//       .toPromise()
//       .then((sesionSTS: ISesionSTS) => {
//         const datosPersona = sesionSTS.datosPersona;
//         return datosPersona.codigoPersona;
//       });
//   };

//   private getPerfiles = (perfilesSTS: any) => {
//     let perfiles = [];
//     let especialistaPerfil = [
//       TipoPerfilSTS.EspecialistaOperaciones,
//       TipoPerfilSTS.NotificadorOperaciones,
//     ];
//     let adminPerfil = [
//       TipoPerfilSTS.JefeOperaciones,
//       TipoPerfilSTS.IngenieroOperaciones,
//       TipoPerfilSTS.ApoyoJefeOperaciones,
//     ];
//     perfilesSTS.forEach((operfil) => {
//       if (especialistaPerfil.includes(operfil.codigo)) {
//         if (!perfiles.includes(TipoPerfilSIGO.EspecialistaOperaciones)) {
//           perfiles.push(TipoPerfilSIGO.EspecialistaOperaciones);
//         }
//       }

//       if (adminPerfil.includes(operfil.codigo)) {
//         if (!perfiles.includes(TipoPerfilSIGO.AdminOperaciones)) {
//           perfiles.push(TipoPerfilSIGO.AdminOperaciones);
//         }
//       }

//       switch (operfil.codigo) {
//         case TipoPerfilSTS.Transportista:
//           perfiles.push(TipoPerfilSIGO.Transportista);
//           break;
//         case TipoPerfilSTS.Certificadora:
//           perfiles.push(TipoPerfilSIGO.Certificadora);
//           break;
//         case TipoPerfilSTS.Abogado:
//           perfiles.push(TipoPerfilSIGO.Abogado);
//           break;
//       }
//     });
//     return perfiles;
//   };

//   getUserSesion = () => {
//     return from(this.getToken()).pipe(
//       switchMap((token) => {
//         this.headers.append("Content-Type", "application/json");
//         this.headers.append("Authorization", "Bearer " + token);
//         return this.http.get(`${this.url}/Autoriza`).pipe(
//           map((sesionSTS: ISesionSTS) => {
//             const datosPersona = sesionSTS.datosPersona;

//             let usuarioSesion: IAppUser = {
//               Id: datosPersona.codigoPersona,
//               UserName: datosPersona.usuario,
//               TTipoEmpresa: 1,
//               TTipoUsuario: 1,
//               Name: datosPersona.nombreCompleto.trim(),
//               TDoc: 1,
//               NDoc: datosPersona.nroDocumento,
//               domicilio: "",
//               telefono: datosPersona.telefono,
//               email: datosPersona.correo,
//               Pais: "PERU",
//               TPais: 1,
//               TPerfil: this.getPerfiles(sesionSTS.perfiles),
//               //Representante
//               TRepresentante: 1,
//               representante: "",
//               tipDocRepresentante: 1,
//               numDocRepresentante: datosPersona.nroDocumento,
//               celularRepre: "",
//               emailRepre: "",
//               //Adicionales
//               registroMTC: "",
//               usuarioInterno: null,
//               pkPeaje: 1,
//               aud: "",
//               exp: "",
//               iat: "",
//               iss: "",
//               jti: "",
//               nbf: "",
//               sub: "",

//               UODes: "",
//               UOJer: "",
//               UOVer: "",
//             };

//             this.userSesion = usuarioSesion;

//             const sesion: ISesion = {
//               appUser: usuarioSesion,
//               sesionSTS: sesionSTS,
//             };

//             return sesion;
//           }),
//           catchError((error) => {
//             console.error(error);
//             return throwError(error);
//           })
//         );
//       }),
//       catchError((error) => {
//         console.error(error);
//         return throwError(error);
//       })
//     );
//   };

//   //Metodo que devuelve una promesa con tipo booleano notificando si
//   //si el usuario esta autenticado
//   public esSesionValida = (): Promise<boolean> => {
//     return this.userManager.getUser().then((user) => {
//       if (this.user !== user) {
//         this._loginChangedSubject.next(this.checkUser(user));
//       }
//       this.user = user;
//       return this.checkUser(user);
//     });
//   };

//   //Metodo para cerrar sesion
//   cierraSesion() {
//     this.userManager.signoutRedirect();
//   }

//   /*SIGNIN - SIGNOUT*/
//   //Metodo que notifica a los suscriptores sobre el nuevo login realizado
//   public finalizaLogin = (): Promise<User> => {
//     return this.userManager.signinRedirectCallback().then((user) => {
//       this.user = user;
//       this._loginChangedSubject.next(this.checkUser(user));
//       return user;
//     });
//   };

//   //Metodo que notifica a los suscriptores sobre el nuevo login realizado
//   public finalizaLogout = () => {
//     this.user = null;
//     return this.userManager.signoutRedirectCallback();
//   };
// }
